import React from "react";
import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip, capitalize } from "@mui/material";
import RectangleIcon from "@mui/icons-material/Rectangle";
import moment from "moment";
import { useNavigate } from "react-router-dom";

interface DataLakesRequestsTableProps { // Changed interface name
    dataLakes: any[]; // Changed prop name
    resourceStatuses: any[];
}

const DataLakesRequestsTable: React.FC<DataLakesRequestsTableProps> = ({ // Changed component name
    dataLakes, // Changed prop name
    resourceStatuses
}: DataLakesRequestsTableProps) => {
    const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
    const navigate = useNavigate();
        
    return (
        <List sx={{ bgcolor: "#fafafa" }}>
            <ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
                <Box width="100%">
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={2.5}><Typography fontSize="12px">DATA LAKE NAME</Typography></Grid> {/* Changed text */}
                        <Grid item xs={1.5}><Typography fontSize="12px">CATEGORY TYPE</Typography></Grid> {/* Changed from DATA SOURCE TYPE */}
                        <Grid item xs={2}><Typography fontSize="12px">CLOUD IDENTIFIER</Typography></Grid>
                        <Grid item textAlign="start" xs={1.5}><Typography fontSize="12px">OWNER</Typography></Grid>
                        <Grid item textAlign="start" xs={2}><Typography fontSize="12px">REQUESTED ON</Typography></Grid>
                        <Grid textAlign="start" item xs={1.5}><Typography fontSize="12px">ACTIONED BY/ REASON</Typography></Grid>
                        <Grid item textAlign="start" xs={1}><Typography fontSize="12px">ACTIONED ON</Typography></Grid>
                    </Grid>
                </Box>
            </ListItem>
            {dataLakes.map((dataLake: any, index: number) => ( // Changed variable name
                <ListItem
                    key={dataLake.id}
                    sx={{
                        border: cardHoverIndex === index ? "1px solid #000" : "1px solid #00000000",
                        mt: 1,
                        cursor: "pointer",
                        bgcolor: dataLake.status === "active" || dataLake.status === "approved" ? "#FFFFFF" : dataLake.status === "rejected" ? "#F0443810" : "#FDB02210", // Changed variable name
                        borderRadius: "8px",
                    }}
                    onClick={() => {
                        navigate(`/datasolutions/requests/data-lakes/${dataLake.id}`); // Changed navigation path
                    }}
                    onMouseEnter={() => setCardHoverIndex(index)}
                    onMouseLeave={() => { setCardHoverIndex(null); }}
                >
                    <Box width="100%" sx={{}}>
                        <Grid container direction="row" alignItems="center" justifyContent="space-between">
                            <Grid item xs={2.5}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <RectangleIcon sx={{ color: dataLake.status === "active" || dataLake.status === "approved" ? "#12B76A" : dataLake.status === "rejected" ? "#F04438" : "#FDB022", bgcolor: dataLake.status === "active" || dataLake.status === "approved" ? "#12B76A" : dataLake.status === "rejected" ? "#F04438" : "#FDB022", width: "4px", marginRight: "8px" }} />
                                    <Typography fontSize="14px" fontFamily="Gilroy-Medium">{dataLake.lakeName}</Typography> {/* Changed field */}
                                    {(dataLake.status === 'active' || dataLake.status === 'approved') && resourceStatuses && resourceStatuses.length > 0 ? ( 
                                        <Tooltip sx={{ whiteSpace: "pre-line" }} title={ <Box key={`${dataLake.id}-tooltip`}>Current Status<br />{resourceStatuses.filter((e:any) => e.resourceId === dataLake.id).map((e: any, i: number) => ( <React.Fragment key={`${dataLake.id}-status-${i}`}>{capitalize(e.currentStatus)}<br /></React.Fragment> ))}</Box> }>
                                            <Avatar src="/assets/info.svg" alt="info" sx={{ height: 16, width: 16, marginLeft: "4px" }} />
                                        </Tooltip>
                                    ) : null}
                                </Box>
                            </Grid>
                            <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataLake.solutionCategoryType || 'N/A'}</Typography></Grid> {/* Changed field */}
                            <Grid item xs={2}><Typography fontSize="14px" fontFamily="Gilroy-Regular" sx={{ textTransform: 'uppercase' }}>{dataLake.cloudProvider || 'N/A'}</Typography></Grid>
                            <Grid item xs={1.5}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Avatar src={dataLake.lakeOwnerAvatar} alt={dataLake.lakeOwnerName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{dataLake.lakeOwnerName ? dataLake.lakeOwnerName.charAt(0).toUpperCase() : ''}</Avatar> {/* Changed fields */}
                                    <Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataLake.lakeOwnerName}</Typography> {/* Changed field */}
                                </Box>
                            </Grid>
                            <Grid item xs={2}>
                                <Box display="flex" alignItems="center"><Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataLake.createdAt ? moment(dataLake.createdAt).format("DD/MM/YYYY | hh:mm A") : 'N/A'}</Typography></Box>
                            </Grid>
                            <Grid item xs={1.5}>
                                {dataLake.status !== "pending" && (
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        {dataLake.lakeApproverName && // Changed field
                                            <Avatar src={dataLake.lakeApproverAvatar} alt={dataLake.lakeApproverName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{dataLake.lakeApproverName.charAt(0).toUpperCase()}</Avatar> // Changed fields
                                        }
                                        {dataLake.lakeApproverName && // Changed field
                                            <Typography fontSize="14px" fontFamily="Gilroy-Regular" mr={1}>{dataLake.lakeApproverName}</Typography> // Changed field
                                        }
                                        {dataLake.status === "rejected" && dataLake.reasonForRejection && (
                                            <Tooltip title={`Reason: ${dataLake.reasonForRejection}`}><img src="/assets/info.svg" alt="info" /></Tooltip>
                                        )}
                                    </Box>
                                )}
                            </Grid>
                            <Grid item xs={1}>
                                {(dataLake.status !== "pending" && dataLake.actionedAt) && (
                                    <Box display="flex" alignItems="center"><Typography fontSize="14px" fontFamily="Gilroy-Regular">{moment(dataLake.actionedAt).format("DD/MM/YYYY | hh:mm A")}</Typography></Box>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </ListItem>
            ))}
        </List>
    );
};

export default DataLakesRequestsTable;